import React, { Component } from 'react';
import PropTypes from 'prop-types';

class PageBanner extends Component {

    render() {

        const { title, description } = this.props;

        return (
            <header className="hero hero hero--default portal-hero hero--default--bg-color">
                <div className="mask">
                    <div className="hero--default--bg-color_shade"></div>
                    <div className="container">
                        <h1>{title}</h1>
                        <p>{description}</p>
                    </div>
                </div>
            </header>
        );
    }
}

PageBanner.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
};

export default PageBanner;


// WEBPACK FOOTER //
// src/client/components/common/elements/PageBanner.js